import { Phone, Clock } from "lucide-react";
import { useEffect, useState } from "react";
import moment from "moment";
import { validCodes, validEvents } from "../constants";

export const OngoingBadge = ({ callerInfo, className }) => {
  const [seconds, setSeconds] = useState(0);
  const [running, setRunning] = useState(false);
  const type = callerInfo?.eventType;
  const code = callerInfo?.code;
  if (!validEvents.includes(type || "") || !validCodes.includes(code || "")) {
    return null;
  }
  useEffect(() => {
    if (!callerInfo?.timestamp) return;

    // START TIMER WHEN ANSWERED
    if (code === "Answered") {
      const start = moment(callerInfo?.timestamp);

      // Calculate initial elapsed time
      const diff = moment().diff(start, "seconds");

      setSeconds(diff > 0 ? diff : 0);
      setRunning(true);
    }

    // STOP TIMER WHEN DISCONNECTED
    if (code === "Disconnected") {
      setRunning(false);
    }
  }, [callerInfo]);

  // Increase timer every second when running
  useEffect(() => {
    if (!running) return;

    const interval = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [running]);

  const formatTime = (secs: number) => {
    const mins = Math.floor(secs / 60);
    const s = secs % 60;
    return `${mins}:${s.toString().padStart(2, "0")}`;
  };
  return (
    <div className={className}>
      <div className="relative">
        <span className="absolute inset-0 rounded-full bg-green-300 opacity-60 animate-ping" />
        <span className="absolute inset-0 rounded-full bg-green-200 opacity-50 animate-pulse" />

        <div className="relative p-2 rounded-full bg-green-200 flex items-center justify-center">
          <Phone className="w-3.5 h-3.5 text-green-600" />
        </div>
      </div>

      <h5 className="text-sm text-green-600">Ongoing call</h5>
      <Clock className="w-4 h-4 stroke-[1] text-green-600" />
      <span className="text-green-600 font-semibold">
        {formatTime(seconds)}
      </span>
    </div>
  );
};
